import React, { useContext } from 'react';
import { Button } from 'antd';
import type { LoginService } from '../../../../service/authorization';
import PKIDownload from '../PKIdownload';
import PKIButton from '../PKIButton';
import { useAccountFactory } from '../../Factory';
import LoginProvider from '../../context';

export default function AccountTab(props: { service: LoginService, styles: any }) {
  const { service, styles } = props;
  const { Username, Password, Form: AccountForm } = useAccountFactory(service);
  const { loading } = useContext(LoginProvider);
  return (
    <AccountForm>
      <Username placeholder="请输入账号" />
      <Password placeholder="请输入密码" />
      <Button type="primary" htmlType="submit" className={styles.loginbtn} loading={loading}>
        登录
      </Button>
      <PKIButton className={styles.pkibtn}/>
      <PKIDownload className={styles.pkidownload} />
    </AccountForm>
  );
} 